import React from 'react';
import { motion } from 'framer-motion';
export function TakeControl() {
  return <section id="control" className="w-full bg-cream py-20 lg:py-28" data-id="element-91" data-mp="rxvfh536spzx">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 lg:grid-cols-2 lg:px-8" data-id="element-92" data-mp="rviok2fgb5aq">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-93" data-mp="mwfsh7hg89ew">
          <img src="https://cdn.magicpatterns.com/uploads/68JVtJctxrEB1q9wAxT5JY/163913912_m.webp" alt="Active seniors enjoying time together at Brightwood" className="aspect-[4/5] w-full rounded-md object-cover shadow-xl" data-id="element-94" data-mp="15np1zgr7yy6h" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-95" data-mp="3mckw199s1lai">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-dark" data-id="element-96" data-mp="2ae4us01yk7v9">
            Your Life, Your Way
          </span>
          <h2 className="mt-3 font-display text-3xl leading-tight text-forest sm:text-4xl" data-id="element-97" data-mp="20lpbmzexdd8s">
            Take Control of Your Next Step
          </h2>
          <div className="mt-4 space-y-4 font-serif text-lg leading-relaxed text-neutral-700" data-id="element-98" data-mp="25esann2h1ewd">
            <p data-id="element-99" data-mp="1qlq3v4qbxqwz">
              Many retirement communities require large buy-ins, restrictive
              contracts, and healthcare decisions that may not align with your
              wishes.
            </p>
            <p className="font-medium text-forest" data-id="element-100" data-mp="1hph4tr69kubd">
              At Brightwood, things are different.
            </p>
            <p className="font-medium text-forest" data-id="element-101" data-mp="3ob3nrarza8o6">
              You own your home. You choose your doctors. You decide how you
              want to live.
            </p>
            <p data-id="element-102" data-mp="3jikakex7dfjw">
              Our residents are active, independent adults who want the benefits
              of community living without sacrificing the freedom they've spent
              a lifetime building.
            </p>
          </div>
          <a href="#connect" className="mt-8 inline-block rounded-sm bg-forest px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-forest-dark" data-id="element-103" data-mp="b53kl1mp3mri">
            Schedule Your Tour
          </a>
        </motion.div>
      </div>
    </section>;
}